<template>
  <div id="EquipmentCurrentStatus">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>

    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Equipment Current Status</div>
          <div class="web-action-btn btn-groups text-right">
              <!-- Button for Clear Cache -->
              <!-- <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data> -->
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'equipmentCurrentStatus'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
            <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
            <section class="bg-white data-table">
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'equipmentCurrentStatus'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                      mode="remote"
                      ref="equipmentCurrentStatusTable"
                      title="equipmentCurrentStatus"
                      @on-page-change="onPageChange"
                      @on-sort-change="onSortChange"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-select-all="onSelectAll"
                      @on-selected-rows-change="selectionChanged"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :paginationOptions="{
                          enabled: false,
                          position: 'both',
                          perPage: perPage,
                          dropdownAllowAll: false,
                          setCurrentPage:listCurrentPage,
                          perPageDropdown:dropDownPerPage,
                      }"
                      :select-options="{
                          enabled: false,
                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                          selectionInfoClass: 'custom-class',
                          selectionText: 'rows selected',
                          clearSelectionText: 'clear',
                      }"
                      :search-options="{
                      enabled: false,
                      }"

                      >
                  </vue-good-table>
              <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
            <div class="bg-white text-center">
                <h1>
                    Oops!</h1>
                <h2>
                    403 </h2>
                <div class="error-details">
                    Sorry!, You don't have permission to access this page.
                </div>
            </div>
        </div>
      </template>
      <template v-else>
          <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {

  name: "EquipmentPoolTransfer",
  metaInfo(){
       return {
         title : 'Equipment Current Status Report | FleetPro Application'
       }
    },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: '',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
        label: "Ownership",
        field: "ownership",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Unit Ownership", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
          label: 'Unit Year',
          field: 'year',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Unit Year", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
        label: "In Service Date",
        field: "date_in_service",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Manufacturer Code",
        field: "manu_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Manufacturer Code", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Model Code",
        field: "model_code",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Model Code", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Equipment Type",
        field: "asset_type",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Equipment Type", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Equipment Type Description",
        field: "equip_type_desc",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Equipment Type Description", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Super Equipment Type",
        field: "sup_equip_type",
        filterable: false,
        sortable: false,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Super Equipment Type", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Super Equipment Type Description",
        field: "sup_equip_type_desc",
        sortable: false,
        filterable: false,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Super Equipment Type Description", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Current Pool",
        field: "current_pool",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Current Pool", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Current Pool Description",
        field: "current_pool_desc",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        sortable: true,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Current Pool Description", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input

          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
          label: 'Current Assigned Facility',
          field: 'location',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Current Location", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Current Location Facility',
          field: 'physical_location',
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Current Location", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Contract Type',
          field: 'conType',
          sortable: false,
          fpFieldType:"option",
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Contract Type", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Agreement Header Type',
          field: 'agree_header',
          sortable: false,
          fpFieldType:"text",
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Agreement Header Type", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Agreement Number',
          field: 'agreement_no',
          // sortable: false,
          fpFieldType:"text",
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Agreement Number", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Customer',
          field: 'customer',
          fpFieldType:"text",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Customer", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Customer Name',
          field: 'customer_name',
          fpFieldType:"text",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Customer Name", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Active Contract',
          field: 'active_contract',
          fpFieldType:"option",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Active Contract", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
        label: "Contract Effective Date",
        field: "effective_date",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Contract Expiry Date",
        field: "expiry_date",
        filterable: true,
        fpFieldType:"custom_date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
          label: 'Contract Days Active',
          field: 'contract_days',
          fpFieldType:"text",
          sortable: false,
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Contract Days Active", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Last Billed Date',
          field: 'last_bill_date',
          fpFieldType:"custom_date",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Last Bill Date", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Last Contract End Date',
          field: 'last_contract_end_date',
          fpFieldType:"custom_date",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Last Contract Date", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Days Off Contract',
          field: 'day_off_contract',
          fpFieldType:"integer",
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Last Contract Date", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [],
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
       {
          label: 'Available',
          field: 'available',
          fpFieldType:"option",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Available", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Overdue',
          field: 'overdue',
          fpFieldType:"option",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Overdue", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Parent Unit',
          field: 'parent_unit',
          fpFieldType:"text",
          sortable: false,
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Parent Unit", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Replaced Unit Number',
          field: 'replaced_unit_no',
          fpFieldType:"text",
          sortable: false,
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Replaced Unit Number", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'On Sales List',
          field: 'sales_list',
          fpFieldType:"option",
          sortable: true,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "On Sales List", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
       {
          label: 'Currently OOS',
          field: 'currently_wo',
          fpFieldType:"option",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "OOS", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
       {
          label: 'Days OOS',
          field: 'days_oos',
          fpFieldType:"integer",
          sortable: false,
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "OOS", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
       {
          label: 'OOS WO or Roster Number',
          field: 'work_order_no',
          fpFieldType:"text",
          sortable: false,
          filterable: true,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "WO", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },

      {
          label: 'Current Reading',
          field: 'current_read',
          fpFieldType:"integer",
          filterable: true,
          type:'number',
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Current Reading", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'UOM',
          field: 'uom',
          fpFieldType:"option",
          filterable: false,
          sortable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "UOM", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['MLS','HRS'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Last Metric Billed To Date',
          field: 'last_metric_bill_to_date',
          fpFieldType:"date",
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Date", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },
      {
          label: 'Last Reading Billed',
          field: 'last_reading_billed',
          fpFieldType:"number",
          filterable: false,
          hidden:false,
          width:'90px',
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Last Reading Billed", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          sortable:false
      },

      {
          label: 'Different Physical Location',
          field: 'different_physical_location',
          fpFieldType:"option",
          sortable: false,
          filterable: true,
          hidden:false,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Active Contract", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: ['Y','N'],
              trigger: "enter" //only trigger on enter not on keyup
          },
      },


    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'equipment_current_status') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },

  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.equipmentCurrentStatusTable.unselectAllInternal();
    },

    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      var selectedRows = [];
      var data = this.$refs['equipmentCurrentStatusTable'].selectedRows;
      for ( var i = 0; i < data.length; i++ ) {
          selectedRows.push(this.$refs['equipmentCurrentStatusTable'].selectedRows[i].id)
      }

      $.ajax({
        url: process.env.ROOT_API + "/equipment-current-status-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action,
          selectedAll:self.serverParams.selectedAll,
          selectedRows:selectedRows,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {

            if ( self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

                self.action = "list";
                // self.loadList();
                return;
            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }
              self.totalRecords = data.content.totalRecords;
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'equipment-current-status')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/EquipmentCurrentStatus.vue